import React from "react";
import Skeleton from "@mui/material/Skeleton";

export function MsbTableRowSkeleton({ index, hiddenHeaders = [] }) {
    return (
        <tr key={index}>
            <td>
                <Skeleton variant="rectangular" width={18} height={18} />
            </td>
            <td>
                <Skeleton variant="text" width="80%" height={24} />
            </td>
            {hiddenHeaders.includes("SECTION") ? null : (
                <td>
                    <Skeleton variant="text" width={70} height={24} />
                </td>
            )}
            {hiddenHeaders.includes("SUBSECTION") ? null : (
                <td>
                    <Skeleton variant="text" width={100} height={24} />
                </td>
            )}
            <td>
                <Skeleton variant="text" width={70} height={24} />
            </td>
            <td>
                <Skeleton variant="text" width={90} height={24} />
            </td>
            <td>
                <Skeleton variant="text" width={90} height={24} />
            </td>
            <td>
                <Skeleton variant="text" width={100} height={24} />
            </td>
            <td>
                <Skeleton variant="rectangular" width={92} height={32} className="oct_skeleton-radius-12" />
            </td>
            <td>
                <button className="oct_dropdown-trigger-v2 oct_skeleton-dropdown-btn" disabled>
                    <Skeleton variant="circular" width={24} height={24} />
                </button>
            </td>
        </tr>
    );
}

export default MsbTableRowSkeleton;
